import { HelpMessage } from 'utils/constants'
import UserTags from 'components/CIMSTags/common/UserTags'
import { UserTagUser } from 'components/CIMSTags/common/UserTags/types'
import { useCASNotificationsContext } from '../../CASNotificationsContext'
import { ApproverTagsProps } from './types'
import CIMSSection from 'components/CIMSSection'

const ApproverTags: React.FC<ApproverTagsProps> = ({ routingGroup }) => {
  const { casRoutingGroups } = useCASNotificationsContext()
  const users = routingGroup
    ? casRoutingGroups?.find(({ id }) => id === routingGroup.id)?.users ?? []
    : casRoutingGroups?.flatMap(({ users }) => users) ?? []
  const uniqueUsers = [...new Set(users.map((u) => JSON.stringify(u)))].map(
    (s) => JSON.parse(s) as UserTagUser
  )
  if (!uniqueUsers.length) return null
  return (
    <CIMSSection
      title="Approvers"
      help={HelpMessage.CAS.Notifications.Approvers(routingGroup)}
    >
      <UserTags users={uniqueUsers} />
    </CIMSSection>
  )
}

export default ApproverTags
